import Vue from "vue";
import Lottie from "vue-lottie/src/lottie.vue";
export default () => {
    Vue.component("Lottie", Lottie);
};
